module.exports = __webpack_public_path__ + "img/coupon-left-pc.f6eaa2e8.png";